/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Edit_Light_Scheduled_No_AdminInputs */



/**
* | output |
* | --- |
* | "This member moves to a Light seat at the next renewal, and a Light seat can't be an admin. To make them one, first undo that change: in the members list, ope..." |
*
* @param {Members_Edit_Light_Scheduled_No_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_edit_light_scheduled_no_admin = /** @type {((inputs?: Members_Edit_Light_Scheduled_No_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Edit_Light_Scheduled_No_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Mitglied wechselt zur nächsten Verlängerung auf einen Light-Platz, und ein Light-Platz kann kein Administrator sein. Nehmen Sie dazu zuerst diese Änderung zurück: Öffnen Sie in der Mitgliederliste das Menü neben dem Mitglied und wählen Sie „Geplante Änderung zurücknehmen“.")
	return /** @type {LocalizedString} */ ("This member moves to a Light seat at the next renewal, and a Light seat can't be an admin. To make them one, first undo that change: in the members list, open the menu next to them and choose “Undo waiting change”.")
});